import { createLightTheme } from '../../utils/createLightTheme';
import { brandWeb } from '../../global/brandColors';
export const webLightTheme = createLightTheme(brandWeb);
